import {useEffect, useState} from 'react';
import {Chart} from 'chart.js/auto';
import {getRequestsDistributionByProductMainCategory} from "../../../APIs/auditor_dashboard";

const useRequestDistributionByProductMainCategory = (chartRef, chartInstanceRef, filters, setLoading) => {
    const [data, setData] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);

    const fetchRequestsDistributionByProductMainCategory = async () => {
        try {
            setLoading(true);
            const response = await getRequestsDistributionByProductMainCategory(filters);
            setData(response.data);
            setDataLoaded(true);
        } catch (error) {
            console.error('Error fetching requests by main category:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (chartRef.current) {
            fetchRequestsDistributionByProductMainCategory();
        }
    }, [chartRef, filters]);

    useEffect(() => {
        if (dataLoaded) {
            if (chartInstanceRef.current) {
                chartInstanceRef.current.destroy();
            }
            const ctx = chartRef.current.getContext("2d");

            Chart.defaults.font.family = 'IRANSansFaNum';

            const sortedData = Object.entries(data).sort((a, b) => b[1] - a[1]);
            const top5 = sortedData.slice(0, 5);
            const othersSum = sortedData.slice(5).reduce((sum, [, value]) => sum + value, 0);
            let labels = [];
            if (othersSum > 0) {
                labels = [...top5.map(([label]) => label), 'سایر'];
            } else {
                labels = [...top5.map(([label]) => label)];
            }
            const chartData = [...top5.map(([, value]) => value), othersSum];

            chartInstanceRef.current = new Chart(ctx, {
                type: 'pie',
                data: {
                    labels: labels,
                    datasets: [{
                        data: chartData,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            display: true,
                            position: 'right',
                            labels: {
                                font: {
                                    size: 12
                                },
                                padding: 15,
                                usePointStyle: true,
                            }
                        },
                        tooltip: {
                            enabled: true,
                            backgroundColor: '#1A237E',
                            titleColor: 'white',
                            bodyColor: 'white',
                            displayColors: false,
                            intersect: false,
                            callbacks: {
                                label: function (tooltipItem) {
                                    const dataset = tooltipItem.chart.data.datasets[0];
                                    const total = dataset.data.reduce((acc, value) => acc + value, 0);
                                    const currentValue = dataset.data[tooltipItem.dataIndex];
                                    const percentage = ((currentValue / total) * 100).toFixed(2);
                                    return `مقدار: ${tooltipItem.formattedValue} (${percentage}%)`;
                                }
                            }
                        },
                    }
                },
            });

            setDataLoaded(false);
        }

    }, [data, dataLoaded, chartRef, chartInstanceRef]);
};

export default useRequestDistributionByProductMainCategory;
